import { render, staticRenderFns } from "./period-reports.vue?vue&type=template&id=465190fe&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465190fe')) {
      api.createRecord('465190fe', component.options)
    } else {
      api.reload('465190fe', component.options)
    }
    module.hot.accept("./period-reports.vue?vue&type=template&id=465190fe&", function () {
      api.rerender('465190fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employees/period-reports.vue"
export default component.exports